import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, watch } from 'vue'

interface BulkEditFormData {
  status?: string
  school?: string
  equipment_type?: string
  minimum_rating?: number | null
  grade_level?: string
  assignee?: string
  notes?: string
}

interface Props {
  show: boolean
  itemCount: number
  submitting?: boolean
  error?: string
  schools?: any[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BulkEditRequestModal',
  props: {
    show: { type: Boolean, default: false },
    itemCount: { default: 0 },
    submitting: { type: Boolean, default: false },
    error: { default: '' },
    schools: { default: () => [] }
  },
  emits: ["close", "submit"],
  setup(__props: any, { emit: __emit }) {

/* eslint-disable no-undef */
const props = __props

const emit = __emit

const showModal = ref(props.show)
const formRef = ref<any>(null)

const localFormData = ref<BulkEditFormData>({
  status: undefined,
  school: undefined,
  equipment_type: undefined,
  minimum_rating: null,
  grade_level: undefined,
  assignee: undefined,
  notes: undefined
})

const statusOptions = [
  { title: 'Pending', value: 'pending' },
  { title: 'Filled', value: 'filled' },
  { title: 'Completed', value: 'completed' },
  { title: 'Denied', value: 'denied' }
]

const equipmentTypeOptions = [
  { title: 'Laptop', value: 'laptop' },
  { title: 'Desktop', value: 'desktop' },
  { title: 'Monitor', value: 'monitor' },
  { title: 'Tablet', value: 'tablet' },
  { title: 'Other', value: 'other' }
]

const gradeLevelOptions = [
  '6', '7', '8', '9', '10', '11', '12'
]

const schoolOptions = ref<any[]>([])

watch(() => props.schools, (newSchools) => {
  schoolOptions.value = newSchools.map((s: any) => ({
    title: s.name,
    value: s.id || s._id
  }))
}, { immediate: true })

watch(() => props.show, (newVal) => {
  showModal.value = newVal
  if (newVal) {
    // Reset form when modal opens
    localFormData.value = {
      status: undefined,
      school: undefined,
      equipment_type: undefined,
      minimum_rating: null,
      grade_level: undefined,
      assignee: undefined,
      notes: undefined
    }
  }
})

watch(showModal, (newVal) => {
  if (!newVal) {
    emit('close')
  }
})

const handleSubmit = async () => {
  // Filter out undefined/null values - only send fields that user filled in
  const updateData: BulkEditFormData = {}

  if (localFormData.value.status !== undefined && localFormData.value.status !== null) {
    updateData.status = localFormData.value.status
  }
  if (localFormData.value.school !== undefined && localFormData.value.school !== null && localFormData.value.school !== '') {
    updateData.school = localFormData.value.school
  }
  if (localFormData.value.equipment_type !== undefined && localFormData.value.equipment_type !== null) {
    updateData.equipment_type = localFormData.value.equipment_type
  }
  if (localFormData.value.minimum_rating !== undefined && localFormData.value.minimum_rating !== null) {
    updateData.minimum_rating = localFormData.value.minimum_rating
  }
  if (localFormData.value.grade_level !== undefined && localFormData.value.grade_level !== null) {
    updateData.grade_level = localFormData.value.grade_level
  }
  if (localFormData.value.assignee !== undefined && localFormData.value.assignee !== null && localFormData.value.assignee !== '') {
    updateData.assignee = localFormData.value.assignee
  }
  if (localFormData.value.notes !== undefined && localFormData.value.notes !== null && localFormData.value.notes !== '') {
    updateData.notes = localFormData.value.notes
  }

  emit('submit', updateData)
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showModal).value = $event)),
    "max-width": "800px",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "modal-header" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, "Bulk Edit Requests (" + _toDisplayString(__props.itemCount) + " items)", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "pt-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_alert, {
                type: "info",
                variant: "tonal",
                class: "mb-4"
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode(" Only fill in the fields you want to update. Empty fields will be left unchanged. ", -1)
                ]))]),
                _: 1
              }),
              (__props.error)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "error",
                    variant: "tonal",
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.error), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_form, {
                ref_key: "formRef",
                ref: formRef
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: localFormData.value.status,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localFormData.value.status) = $event)),
                            items: statusOptions,
                            label: "Status (optional)",
                            variant: "outlined",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: localFormData.value.school,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localFormData.value.school) = $event)),
                            items: schoolOptions.value,
                            label: "School (optional)",
                            variant: "outlined",
                            clearable: ""
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: localFormData.value.equipment_type,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localFormData.value.equipment_type) = $event)),
                            items: equipmentTypeOptions,
                            label: "Equipment Type (optional)",
                            variant: "outlined",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: localFormData.value.minimum_rating,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localFormData.value.minimum_rating) = $event)),
                            modelModifiers: { number: true },
                            label: "Minimum Rating 1-10 (optional)",
                            type: "number",
                            min: "1",
                            max: "10",
                            variant: "outlined",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: localFormData.value.grade_level,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localFormData.value.grade_level) = $event)),
                            items: gradeLevelOptions,
                            label: "Grade Level (optional)",
                            variant: "outlined",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: localFormData.value.assignee,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((localFormData.value.assignee) = $event)),
                            label: "Assignee (optional)",
                            variant: "outlined",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_textarea, {
                            modelValue: localFormData.value.notes,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((localFormData.value.notes) = $event)),
                            label: "Notes (optional)",
                            variant: "outlined",
                            rows: "3",
                            placeholder: "Add notes or comments...",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "grey",
                variant: "text",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close'))),
                disabled: __props.submitting
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode(" Cancel ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "flat",
                onClick: handleSubmit,
                loading: __props.submitting
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode(" Apply Changes ", -1)
                ]))]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})